import(/* webpackMode: "eager", webpackExports: ["OffersHero"] */ "/vercel/path0/src/app/offres/_components/offers-hero.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["OffersHesitationSection"] */ "/vercel/path0/src/app/offres/_components/offers-hesitation-section.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["OffersPricingCards"] */ "/vercel/path0/src/app/offres/_components/offers-pricing-cards.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["AppointmentSection"] */ "/vercel/path0/src/components/sections/appointment-section.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["FaqSection"] */ "/vercel/path0/src/components/sections/faq-section.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["HomeSectionScroll"] */ "/vercel/path0/src/components/sections/home-section-scroll.tsx");
